import { IS_CHAT_PRE_FETCH_ENABLED, IS_GROUP_PRE_FETCH_ENABLED } from '@/processENV';

export const SYNC_CONSTANTS = {
   CHAT_HISTORY_FETCH_LIMIT: 50,
   BATCH_SIZE: 10,
   INITIAL_SYNC_CHAT_LIMIT: 20,
   RECENT_CHAT_FETCH_LIMIT: 50,
   PARTICIPANT_SYNC_BATCH_SIZE: 5,
   CHAT_SYNC_CONFIG: {
      preFetch: IS_CHAT_PRE_FETCH_ENABLED,
      isSinglePage: true,
   },
   GROUP_SYNC_CONFIG: {
      preFetch: IS_GROUP_PRE_FETCH_ENABLED,
   },
};
